import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getPAOccupationStart,
  getPAOccupationSuccess,
  getPAOccupationFailure,
} from "../reducers/getPAOccupationReducer.js";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const getPAOccupation = createAsyncThunk(
  "getPAOccupation",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(getPAOccupationStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/PA/GetOccupations`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getPAOccupationSuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getPAOccupationFailure(error.response.data.Message));
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
